"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PausableTokenFactory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Approval",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
        ],
        name: "OwnershipRenounced",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [],
        name: "Pause",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Transfer",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [],
        name: "Unpause",
        type: "event",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "_owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "_spender",
                type: "address",
            },
        ],
        name: "allowance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_value",
                type: "uint256",
            },
        ],
        name: "approve",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "_owner",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_subtractedValue",
                type: "uint256",
            },
        ],
        name: "decreaseApproval",
        outputs: [
            {
                internalType: "bool",
                name: "success",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_addedValue",
                type: "uint256",
            },
        ],
        name: "increaseApproval",
        outputs: [
            {
                internalType: "bool",
                name: "success",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [],
        name: "pause",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "paused",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_value",
                type: "uint256",
            },
        ],
        name: "transfer",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_from",
                type: "address",
            },
            {
                internalType: "address",
                name: "_to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_value",
                type: "uint256",
            },
        ],
        name: "transferFrom",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [],
        name: "unpause",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
class PausableTokenFactory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (args.length === 1) {
            super(_abi, _bytecode, args[0]);
        }
        else {
            super(...args);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.PausableTokenFactory = PausableTokenFactory;
PausableTokenFactory.bytecode = _bytecode;
PausableTokenFactory.abi = _abi;
//# sourceMappingURL=PausableTokenFactory.js.map